export default __webpack_public_path__ + "static/media/cApeLogo.cbbd0034.png";